var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOngoingIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99996 0.666992C5.83996 0.666992 7.33329 2.16033 7.33329 4.00033C7.33329 5.84033 5.83996 7.33366 3.99996 7.33366C2.15996 7.33366 0.666626 5.84033 0.666626 4.00033C0.666626 2.16033 2.15996 0.666992 3.99996 0.666992ZM3.99996 6.66699C5.47329 6.66699 6.66663 5.47366 6.66663 4.00033C6.66663 2.52699 5.47329 1.33366 3.99996 1.33366C2.52663 1.33366 1.33329 2.52699 1.33329 4.00033C1.33329 5.47366 2.52663 6.66699 3.99996 6.66699ZM5.17863 2.35033L5.64996 2.82166L3.99996 4.47166L3.52863 4.00033L5.17863 2.35033Z",
    fill: "#2A5392"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOngoingIc);
export default __webpack_public_path__ + "static/media/ongoing-ic.7b9564f99cf168f03dd70a7f93981c8b.svg";
export { ForwardRef as ReactComponent };